import '@nike/eds/dist/index.css'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Security, LoginCallback } from '@okta/okta-react'
import React, { useCallback, useMemo } from 'react'
import { Navigate, Route, Routes, useNavigate, useSearchParams } from 'react-router-dom'
import { oktaAuth } from './config/OktaConfig'
import { LoginError } from './login-error/LoginError'
import { RequiredAuth } from './shared/AuthenticatedRoute'
import '@nike/eds/dist/index.css'
import { createBrowserHistory } from 'history'
import {FlowOverview} from "./pages/FlowOverview";
import {MasterData} from "./pages/MasterData";
import {Exceptions} from "./pages/Exceptions";
import {Dashboard} from "./pages/Dashboard";
import {EquipmentVehicles} from "./pages/EquipmentVehicles";
import {SideBar} from "./shared/header/SideBar";
import { Header } from './shared/header/Header'

const history = createBrowserHistory()
const verticalNavStyle = {
    height: "100vh"
}
type AppInSecureContextProps = {
    globalSearch: string;
    currentGeos: string[];
};

const AppInSecureContext: React.FC<AppInSecureContextProps> = ({ globalSearch, currentGeos }) => {
    /*
    const roles = useRoleManagement();
    console.log("Roles for current user: ", roles);
    */

    return  <>
                { /* <TrackUserId /> */ }
                <Routes>
                    <Route element={<RequiredAuth/>}>
                        <Route path="/dashboard/*" element={<Dashboard history={history} />}/>
                        <Route path="/exceptions/:id?" element={<Exceptions history={history} globalSearch={globalSearch} currentGeos={currentGeos}/>}/>
                        <Route path="/master-data/*" element={<MasterData history={history} />}/>
                        <Route path="/flow-overview/*" element={<FlowOverview history={history} />}/>
                        <Route path="/equipment-vehicles/*" element={<EquipmentVehicles history={history} />}/>
                        <Route path="/" element={<Navigate to="/dashboard"/>}/>
                    </Route>
                    <Route path="/implicit/callback" element={<LoginCallback errorComponent={LoginError}/>}/>
                </Routes>
            </>
}

const App = () => {
    const navigate = useNavigate();
    const restoreOriginalUri = useCallback(
        (_oktaAuth: any, originalUri: string) => {
            navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
        },
        [navigate]
    );
    const [searchParams, setSearchParams] = useSearchParams();

    // Initialize globalSearch from the URL search param
    const initialSearch = searchParams.get('search') || '';
    const [globalSearch, setGlobalSearch] = React.useState<string>(initialSearch);
    const [currentGeos, setCurrentGeos] = React.useState<string[]>(['US']); 
    
    function useDebounce(value: string, delay: number): string {
        const [debouncedValue, setDebouncedValue] = React.useState(value);
        React.useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);            
            }, delay);
            return () => {
                clearTimeout(handler);
            };
        }, [value, delay]);
        return debouncedValue;
    }

    const debouncedGlobalSearch = useDebounce(globalSearch, 300);

    // Keep globalSearch and the URL in sync
    React.useEffect(() => {
        if (globalSearch) {
            searchParams.set('search', globalSearch);
            setSearchParams(searchParams, { replace: true });
        } else {
            searchParams.delete('search');
            setSearchParams(searchParams, { replace: true });
        }
    }, [globalSearch, setSearchParams]);

    
    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <div className="eds-flex" style={verticalNavStyle}>
                <SideBar/>
                <div className="eds-flex--grow-1">
                    <Header isDark={false} globalSearch={globalSearch} setGlobalSearch={setGlobalSearch} currentGeos={currentGeos} setCurrentGeos={setCurrentGeos} />
                    <div className="scrollable">
                        <AppInSecureContext globalSearch={debouncedGlobalSearch} currentGeos={currentGeos} />
                    </div>
                </div>
            </div>
        </Security>
    );
}

export default App
